const SET_THEME_MODE = 'SET_THEME_MODE'
const SET_THEME_DIRECTION = 'SET_THEME_DIRECTION'

export { SET_THEME_MODE, SET_THEME_DIRECTION }
